import React from "react";
import "./Landing.css";
import { Link } from "react-router-dom";
import landingImage from "../../Assets/vectors/landing.svg";

export default function Landing() {
  return (
    <div className="grid grid2Fr landing">
      <div style={{ marginTop: "72px" }} className="landingContent">
        <h2 style={{ fontWeight: "700" }}>
          Inspiration, Motivation and Education .
        </h2>
        <h1 className="mb05">Better Education For A Better World.</h1>
        <p className="mb2" style={{ fontWeight: "500" }}>
          Any successful career starts with good education. Together with us you
          will have deeper knowledge of the subjects that will be especially
          useful for you when climbing the career ladder.
        </p>
        <Link to="/admission">
          <button className="bt ripple" style={{ width: "192px" }}>
            Enroll For Admission
          </button>
        </Link>
      </div>
      <div className="imageContainer">
        <img src={landingImage} alt="" />
      </div>
    </div>
  );
}
